module.exports = __webpack_public_path__ + "img/PPMP37.a743e4f7.png";